import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import SmallPopup from "../../../_utils/CommonSmallPopup";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { createFieldForceAccount } from "../../../../redux/features/accounts/fieldForceAccount";
import { editBeneficiary } from "../../../../redux/features/accounts/beneficiaryAccount/createAccount";
import {
  buildSwitchFieldForceEditPayload,
  persistFieldForceCreateError,
} from "../../../../utils/fieldForceCreateError";
import CommonToast from "../../../_utils/CommonToast";
import ICONS from "../../../../assets/Icons";
import ConfidentialCard from "../../../_utils/TransactionCommonComponents/ConfidentialCard";
import TEXT from "../../../../utils/globalText";
import CommonLayout from "../../../_utils/CommonLayout";
import PanDetails from "../../../_utils/AccountCreationComponents/PanDetails";
import GstDetails from "../../../_utils/AccountCreationComponents/GstDetails";
import BankDetails from "../../../_utils/AccountCreationComponents/BankDetails";
import AdditionalRecipients from "../../../_utils/AccountCreationComponents/AdditionalRecipients";
import CategoriesEdit from "../../../_utils/AccountCreationComponents/CategoriesEdit";
import AssignLabels from "../../../_utils/AccountCreationComponents/AssignLabels";
import ConfirmCreateAccountPopup from "../../../_utils/ConfirmCreateAccountPopup";
import ContactDetails from "../../../_utils/AccountCreationComponents/ContactDetails";
import CommonDestinationAccount from "../../../_utils/TransactionCommonComponents/CommonDestinationAccount";

const FieldForceConfirmAccount = React.memo(
  ({
    payload,
    selectedFields,
    selectedCatFields,
    setShowModalPopup,
    showModalPopup,
    recipients,
    createFieldForceAccountLoading,
    manualVirtualAccount,
    type,
    bene_acc_id,
  }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { categoriesData } = useSelector((state) => state.sharedResources);
    const activeCategories =
      categoriesData?.categories?.filter(
        (category) => category?.active === "Y",
      ) ?? [];
    const categoriesToPreview =
      type !== "switch_account" && selectedCatFields.length === 0
        ? activeCategories.map((category) => category.id)
        : selectedCatFields;

    const [activeType, setActiveType] = useState("Pan");

    const handleClick = async () => {
      try {
        let updatedPayload = { ...payload, navigate };

        if (
          selectedFields.length === categoriesData?.categories?.length ||
          selectedFields.length === GlobalConfiguration.lengthCheckZero
        ) {
          updatedPayload.categories = null;
        } else {
          updatedPayload = {
            ...updatedPayload,
            categories: selectedFields.toString(),
          };
        }
        if (type !== "switch_account") {
          updatedPayload.category_ids =
            selectedCatFields.length === GlobalConfiguration.lengthCheckZero ||
            selectedCatFields.length === activeCategories.length
              ? []
              : selectedCatFields;
        }

        let data;
        if (type === "switch_account") {
          if (!updatedPayload?.linked_user_id) {
            CommonToast({
              text: "Please link a user before switching to field force account.",
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
            return;
          }

          data = await dispatch(
            editBeneficiary(
              buildSwitchFieldForceEditPayload({
                bene_acc_id,
                updatedPayload,
                navigate,
              }),
            ),
          ).unwrap();
        } else {
          data = await dispatch(
            createFieldForceAccount(updatedPayload),
          ).unwrap();
        }

        const accountId = data?.field_force_accounts?.[0]?.id || bene_acc_id;

        if (data?.status === true) {
          navigate(
            `/field_force_account_dashboard/create_field_force_account/success/${accountId}`,
            {
              replace: true,
              state: { type },
            },
          );
        }
      } catch (error) {
        navigate(
          `/field_force_account_dashboard/create_field_force_account/error`,
          {
            replace: true,
            state: persistFieldForceCreateError(error),
          },
        );

        return error;
      }
    };

    const [isalertPopup, setAlertPopUp] = useState(false);
    const [currentAssociate, setCurrentAssociate] = useState(
      "Field force account",
    );
    return (
      <>
        {isalertPopup && (
          <div className="fixed z-z-index-max flex  items-center justify-center  top-left-base left-left-base w-width-full h-height-full bg-custom-backdrop bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle="Open in full view?"
              headerFontWeight="semibold"
              headerFontColor="emphasis"
              textSize="font-lg"
              subtext="Opening in full view will leave this page and exit the current flow."
              btnOneText="Stay"
              btnOneHandleFunction={() => setAlertPopUp(false)}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoHandleFunction={() => {
                setAlertPopUp(false);
                navigate(
                  "/field_force_account_dashboard/field_force_account_view_all",
                );
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={true}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {showModalPopup && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <ConfirmCreateAccountPopup
              pan={payload?.panNumber}
              ifsc={payload?.ifsc_code}
              bank={payload?.bank_account}
              activeType={activeType}
              setActiveType={setActiveType}
              setShowModalPopup={setShowModalPopup}
              dropDownNo={GlobalConfiguration?.lengthCheckTwo}
              currentAssociate={currentAssociate}
              setCurrentAssociate={setCurrentAssociate}
              handleClick={handleClick}
              createFieldForceAccountLoading={createFieldForceAccountLoading}
            />
          </div>
        )}
        <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base">
          <CommonLayout>
            <div className="flex flex-col gap-gap-md Qsmd:pb-padding-md">
              {" "}
              <PanDetails
                panNumber={payload?.panNumber}
                legalName={payload?.legalName}
                previewMode={true}
              />
              {manualVirtualAccount && (
                <div>
                  <ConfidentialCard
                    icon={ICONS.VIRTUAL_ACCOUNT}
                    title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                    note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                    toggleState={manualVirtualAccount}
                    isPreview={true}
                  />
                </div>
              )}
              <BankDetails payload={payload} previewMode={true} />
            </div>

            <div className="flex flex-col gap-gap-md">
              <ContactDetails
                previewMode={true}
                payload={payload}
                accountName={payload?.account_name}
                contactNumber={payload?.contact_no}
                emailId={payload?.email_id}
              />
              <CategoriesEdit
                sortedCategories={categoriesData?.categories}
                selectedCategories={categoriesToPreview}
                Title="Categories"
                isPreview={true}
                flow={type}
              />

              <CommonDestinationAccount
                variant="user"
                isOptional={false}
                transactionPayload={payload}
                isReadOnly
              />

              <AssignLabels
                previewMode={true}
                labels={payload?.labels}
                isOptional={true}
              />

              {/* Delete this  */}
              <AdditionalRecipients
                previewMode={true}
                recipients={recipients}
              />
              {/* Delete this  */}
            </div>
          </CommonLayout>
        </div>
      </>
    );
  },
);

export default FieldForceConfirmAccount;
